@if (pkg$$ | async; as pkg) {
  <div class="page">
    <store-header-container
      [iconUrl]="pkg.icon"
      [title]="pkg.name"
      [tagline]="pkg.tagline"
      [prerequisite]="productNameForSingleAddon$ | async"
      [chipLabels]="lmiCategories$ | async"
      [appPrice]="appPrice"
      [showAction]="showActionButton"
      [showPricing]="showPricing"
      [actionLabel]="actionLabel | translate"
      [actionEnabled]="this.enableAddToCart"
      [hideTags]="this.hideTags"
      (actionSelected)="emitGetItNow()"
      (contactActionClick)="handleContactActionClick()"
    ></store-header-container>
    @if (pkg?.content) {
      <section class="white-background package-description">
        <store-selling-info [description]="pkg.content"></store-selling-info>
      </section>
    }
    <store-products-nav-v2
      [items]="orderedLineItems$ | async"
      [hideItemsNav]="pkg?.hide_product_icons_and_names"
      (itemSelected)="selectItem($event)"
    ></store-products-nav-v2>
    @if (selectedItem$ | async; as selectedItem) {
      @if (!pkg?.hide_product_details) {
        <div class="package-content">
          <div class="left-column">
            @if (selectedItem?.item?.description || selectedItem?.item?.keySellingPoints) {
              <section
                class="white-background product-description"
                >
                <store-selling-info
                  [description]="selectedItem?.item?.description"
                  [keySellingPoints]="selectedItem?.item?.keySellingPoints"
                ></store-selling-info>
              </section>
            }
            @if (selectedItem?.item?.faqs?.length > 0 && selectedItem?.item?.faqs[0].question) {
              <section>
                <h2 class="va-component-title">
                  {{ 'FRONTEND.STORE.FAQS' | translate }}
                </h2>
                <store-faqs [faqs]="selectedItem.item.faqs"></store-faqs>
              </section>
            }
          </div>
          <div class="right-column">
            @if (selectedItem?.item?.screenshotUrls?.length > 0) {
              <section>
                <h2 class="va-component-title">
                  {{ 'FRONTEND.STORE.GALLERY' | translate }}
                </h2>
                <va-image-gallery [imageUrls]="selectedItem.item.screenshotUrls"></va-image-gallery>
              </section>
            }
            @if (selectedItem?.item?.files?.length > 0) {
              <section>
                <h2 class="va-component-title">
                  {{ 'FRONTEND.STORE.FILES' | translate }}
                </h2>
                <store-files [files]="selectedItem.item.files"></store-files>
              </section>
            }
          </div>
        </div>
      }
    }
  </div>
}
